/**
 * Mailchimp's archive HTML carries no <base>, so a link inside the letter would
 * navigate the reader iframe itself and strand the user on a newsletter with no
 * way back. Injecting `target="_blank"` sends them to a new tab instead.
 */
export const asReaderDocument = (html: string): string => {
  const base = '<base target="_blank">';
  return /<head[^>]*>/i.test(html) ? html.replace(/<head([^>]*)>/i, `<head$1>${base}`) : base + html;
}
